import { placeholder } from "utils/assets_exports/images";
import SVG from "../core/SVG";
import { PollTextProps } from "./PollText";
import { useRef } from "react";

export type PollImageProps = PollTextProps;

const PollImage = ({
    poll,
    updatePollOption,
    handleShowThirdPoll,
    handleRemoveThirdPoll,
    className,
    style
}: PollImageProps) => {
    const pollImgFirstRef = useRef(null);
    const pollImgSecondRef = useRef(null);
    const pollImgThirdRef = useRef(null);
    return (
        <div className={`form-panel img-poll-panel ${className}`} style={style}>
            {/* first option  */}
            <div className=" d-flex flex-j-between flex-a-start gap-10">
                <div className="field p-relative w-full img-poll-field">
                    <label>First Option</label>
                    <div className="control">
                        <img
                            className="cursor-pointer"
                            src={
                                poll.firstOption
                                    ? URL.createObjectURL(
                                          poll.firstOption[0] as File
                                      )
                                    : placeholder
                            }
                            alt=""
                            onClick={() =>
                                (
                                    pollImgFirstRef.current as unknown as HTMLInputElement
                                ).click()
                            }
                        />
                        <input
                            type="file"
                            className="is-hidden"
                            accept="image/png, image/jpeg"
                            ref={pollImgFirstRef}
                            onChange={(e) =>
                                updatePollOption(e.target.files as FileList, 0)
                            }
                        />
                    </div>
                </div>

                <span className="close-wrap d-flex flex-j-end mt-20">
                    <span className="custom-close-modal">
                        {/* <SVG svg="x" size={16} />  */}
                    </span>
                </span>
            </div>

            {/* second option  */}
            <div className=" d-flex flex-j-between flex-a-start gap-10">
                <div className="field p-relative w-full img-poll-field">
                    <label>Second Option</label>
                    <div className="control">
                        <img
                            className="cursor-pointer"
                            src={
                                poll.secondOption
                                    ? URL.createObjectURL(
                                          poll.secondOption[0] as File
                                      )
                                    : placeholder
                            }
                            alt=""
                            onClick={() =>
                                (
                                    pollImgSecondRef.current as unknown as HTMLInputElement
                                ).click()
                            }
                        />
                        <input
                            type="file"
                            className="is-hidden"
                            accept="image/png, image/jpeg"
                            ref={pollImgSecondRef}
                            onChange={(e) =>
                                updatePollOption(e.target.files as FileList, 1)
                            }
                        />
                    </div>
                </div>

                {/* ${poll.thirdOption != undefined ? "custom-is-hidden" : ""} */}
                <span className={`close-wrap d-flex flex-j-end mt-20 `}>
                    <span
                        className={`custom-close-modal ${poll.thirdOption != undefined ? "is-disabled" : ""}`}
                        onClick={handleShowThirdPoll}
                    >
                        <SVG svg="plus" size={16} />
                    </span>
                </span>
            </div>

            {/* third option  */}
            {poll.thirdOption != undefined ? (
                <div className="d-flex flex-j-between flex-a-start gap-10">
                    <div className="field p-relative w-full img-poll-field">
                        <label>Third Option</label>
                        <div className="control">
                            <img
                                className="cursor-pointer"
                                src={
                                    poll.thirdOption
                                        ? URL.createObjectURL(
                                              poll.thirdOption[0] as File
                                          )
                                        : placeholder
                                }
                                alt=""
                                onClick={() =>
                                    (
                                        pollImgThirdRef.current as unknown as HTMLInputElement
                                    ).click()
                                }
                            />
                            <input
                                type="file"
                                className="is-hidden"
                                accept="image/png, image/jpeg"
                                ref={pollImgThirdRef}
                                onChange={(e) =>
                                    updatePollOption(
                                        e.target.files as FileList,
                                        2
                                    )
                                }
                            />
                        </div>
                    </div>

                    <span className="close-wrap d-flex flex-j-end mt-20">
                        <span
                            className="custom-close-modal"
                            onClick={handleRemoveThirdPoll}
                        >
                            <SVG svg="x" size={16} />
                        </span>
                    </span>
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default PollImage;
